import { useEffect, useState } from 'react';
import { useForm, yupResolver, } from '@mantine/form';
import { TextInput, Modal, Text, Center, Button, Code, Checkbox, SimpleGrid, NumberInput } from '@mantine/core';

import { useParams } from 'react-router-dom';
import useGetCustomPageDetails from './useGetCustomPage';
import useEdit from './useEdit';

import { object, string, number } from "yup";
import LoadingErrorContainer from '../../../components/placeholders/LoadingErrorContainer';
import CustomRichTextEditor from '../../../components/textEditor/CustomTextRichEditor';
import { useDisclosure } from '@mantine/hooks';

const userSchema = object().shape({
    name: string()
        .required("Name is required")
        .min(3, "Name must be at least 3 characters"),


});
function Demo() {
    const {
        editMutation
    } = useEdit()

    const [selectedFile, setSelectedFile] = useState(null);

    // const handleFileChange = (event) => {
    //     console.log(event); // Log the event
    //     if (event.target && event.target.files && event.target.files[0]) {
    //         const file = event.target.files[0];
    //         setSelectedFile(file);
    //     } else {
    //         console.log('No file selected or event target is undefined');
    //     }
    // };
    const params = useParams();
    const { id } = params; // Assuming params.id is the id you want to pass

    const [isDataSet, setIsDataSet] = useState(true);

    const { data, isPending, isError } = useGetCustomPageDetails();

    useEffect(() => {

        form?.setValues({
            ...data,

        })

        if (!isPending) {
            setTimeout(() => {
                setIsDataSet(false)
            }, 300);
        }



    }, [data, isPending]);

    const [submittedValues] = useState('');

    const form = useForm({
        // mode: 'uncontrolled',
        initialValues: {
            id: "",
            description: "",
        },
        validate: yupResolver(userSchema)
    });



    const handleEdit = form.onSubmit(async (values) => {

        const formData = new FormData();
        formData.append("id", values?.id);
        formData.append("description", values?.description === undefined || values?.description === null ? "" : values?.description);
        formData.append("description_fr", values?.description_fr === undefined || values?.description_fr === null ? "" : values?.description_fr);
        formData.append("description_ar", values?.description_ar === undefined || values?.description_ar === null ? "" : values?.description_ar);
        formData.append("description_it", values?.description_it === undefined || values?.description_it === null ? "" : values?.description_it);
        formData.append("description_de", values?.description_de === undefined || values?.description_de === null ? "" : values?.description_de);
        formData.append("description_es", values?.description_es === undefined || values?.description_es === null ? "" : values?.description_es);
        formData.append("description_pt", values?.description_pt === undefined || values?.description_pt === null ? "" : values?.description_pt);
        formData.append("description_nl", values?.description_nl === undefined || values?.description_nl === null ? "" : values?.description_nl);
        editMutation.mutate(formData)
    })

    const [opened, { open, close }] = useDisclosure(false);
    return (
        <LoadingErrorContainer isLoading={isPending || isDataSet}>
            <h1>Edit CustomPage</h1>

            <SimpleGrid cols={1}>

                <TextInput
                    label="Name "
                    placeholder="Enter Name"
                    key={form.key('name')}
                    disabled
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('name')}
                />


                <label class="m_8fdc1311">English Description </label>
                <CustomRichTextEditor
                    {...form.getInputProps('description')}
                />
                <label class="m_8fdc1311">French Description</label>
                <CustomRichTextEditor
                    {...form.getInputProps('description_fr')}
                />
                <label class="m_8fdc1311"> Arabic Description</label>
                <CustomRichTextEditor
                    {...form.getInputProps('description_ar')}
                />
                <label class="m_8fdc1311">Italian Description</label>
                <CustomRichTextEditor
                    {...form.getInputProps('description_it')}
                />
                <label class="m_8fdc1311">German Description</label>
                <CustomRichTextEditor
                    {...form.getInputProps('description_de')}
                />
                <label class="m_8fdc1311">Spanish Description</label>
                <CustomRichTextEditor
                    {...form.getInputProps('description_es')}
                />
                <label class="m_8fdc1311">Portuguese Description</label>
                <CustomRichTextEditor
                    {...form.getInputProps('description_pt')}
                />
                <label class="m_8fdc1311">Dutch Description</label>
                <CustomRichTextEditor
                    {...form.getInputProps('description_nl')}
                />



            </SimpleGrid>
            <Button type="submit" mt="md" onClick={handleEdit} loading={editMutation?.isPending}>
                Submit
            </Button>
            &nbsp;
            <Button type="button" mt="md" color="red" onClick={open} >
                Return
            </Button>

            <Modal opened={opened} onClose={close}
                centered
                title="Confirm">

                <Text>Are you sure you want to leave this page without saving?</Text>


                <Center mt={"md"}>
                    <Button onClick={() => window.history.back()}
                    >Confirm</Button>
                </Center>

            </Modal >
            {submittedValues && (
                <Code block mt="md">
                    {submittedValues}
                </Code>
            )}
        </LoadingErrorContainer>
    );
}



export default Demo;
